<template>
  <v-data-table
    :headers="headers"
    :items="payments"
    sort-by="model"
    class="elevation-1 dark-last-row"
    hide-default-header
    hide-default-footer
    :loading="loading"
    mobile-breakpoint="false"
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    item-key="id"
    show-expand
  >
    <template v-slot:top>
      <v-toolbar
        flat
        color="#004889"
      >
        <v-toolbar-title class="white--text">Payments</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
          scrollable
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              tile
              small
            >
              <v-icon dark>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>
          <v-card flat color="#004889">
            <v-card-title class="accent">
              <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text class="pa-0">
              <ValidationObserver ref="observer1">
                <v-form ref="warrantyform">
                  <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Payment Description</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Payment Description" rules="required">
                            <v-text-field
                                v-model="editedItem.payment_description"
                                solo
                                dark
                                flat
                                required
                                :error-messages="errors"
                            ></v-text-field> 
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Amount</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-text-field
                                v-model="editedItem.amount"
                                prefix="$"
                                solo
                                flat
                                dark
                            ></v-text-field>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Payment Type</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-select
                                v-model="editedItem.payment_type"
                                :items="amountTypes"
                                item-text="label"
                                item-value="value"
                                required
                                :error-messages="errors"
                                solo
                                flat
                                dark
                            ></v-select>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row" v-if="editedItem.payment_type == 'check'">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Check #</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Check #" rules="required">
                            <v-text-field
                                v-model="editedItem.check_num"
                                solo
                                dark
                                flat
                                required
                                :error-messages="errors"
                            ></v-text-field> 
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Date</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-menu
                                v-model="menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="computedDateFormatted"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    solo
                                    flat
                                    dark
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="editedItem.date"
                                @input="menu = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-form>
              </ValidationObserver>
            </v-card-text>

            <v-card-actions class="accent">
              <v-btn
                large min-width="49%" color="white" text
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                large min-width="49%" color="primary" tile
                @click="save"
                :loading="loading"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card color="red">
            <v-card-title class="subtitle-2 justify-center white--text">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions class="red darken-4">
              <v-spacer></v-spacer>
              <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
      <v-btn large min-width="50%" color="primary" tile @click="editItem(item)">      
        <v-icon
        >
          mdi-pencil
        </v-icon>
      </v-btn>             
      <v-btn large min-width="50%" color="red" tile @click="deleteItem(item.id)">
        <v-icon
        color="white"
        >
        mdi-delete
      </v-icon>  
      </v-btn>  
      </td>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="getPayments"
        tile
        :loading="loading"
      >
        No Payments Found!
      </v-btn>
    </template>
    <template v-slot:item.amount="{ item }">
      <span>{{ item.amount | currency }}</span>
    </template>
    <template v-slot:item.date="{ item }">
      <span>{{ formatDate(item.date) }}</span>
    </template>
    <template v-slot:footer>
      <tr style="vertical-align: middle; font-size: 13px;" class="blue-grey lighten-5">
        <td width="100%" colspan="2" class="text-right"><strong>Total Paid:</strong></td><td>{{ '$' + obj.total_paid }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
    import axios from 'axios'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import mixin from '../../mixin/main.js'
    import { mapGetters } from 'vuex'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        mixins: [mixin],
        props: ['job', 'obj'],
        data: () => ({
            loading: false,
            dialog: false,
            dialogDelete: false,
            expanded: [],
            singleExpand: false,
            headers: [
                {
                  text: 'Description',
                  align: 'start',
                  sortable: false,
                  value: 'payment_description',
                },
                { text: 'Date', value: 'date', sortable: false },
                { text: 'Amount', value: 'amount', sortable: false },
                { text: '', value: 'data-table-expand' },
            ],
            payments: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                payment_description: '',
                amount: '',
                date: new Date().toISOString().substr(0, 10),
                payment_type: '',
                check_num: ''
            },
            defaultItem: {
                id: '',
                payment_description: '',
                amount: '',
                date: new Date().toISOString().substr(0, 10),
                payment_type: '',
                check_num: ''
            },
        }),

        components: {
            ValidationProvider,
            ValidationObserver,
        },

        computed: {
            ...mapGetters({
                amountTypes: 'data/amountTypes'
            }),
            formTitle () {
                return this.editedIndex === -1 ? 'New Payment' : 'Edit Payment'
            },
            computedDateFormatted () {
                return this.formatDate(this.editedItem.date)
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        created () {
            this.getPayments()
        },

        methods: {
            getPayments() {
                if(this.job) {
                    this.loading = true
                    axios.get('crm/job/payments/get?id=' + this.job)
                        .then(response => {
                            this.loading = false
                            this.payments = response.data
                            this.$nextTick()
                        })
                }
            },

            editItem (item) {
                this.editedIndex = this.payments.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (id) {
                this.editedIndex = id
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.loading = true
                axios.delete('crm/job/payments/delete?id=' + this.editedIndex)
                    .then(() => {
                      this.closeDelete()
                      this.getPayments()
                      this.$emit('update-job')
                      this.$nextTick()
                    })
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                })
            },

            async save () {
                if (this.editedIndex > -1) {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('crm/job/payments/update', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getPayments()
                          this.$emit('update-job')
                          this.close()
                      }).catch(error => {
                          console.log(error)
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                } else {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      this.$set(this.editedItem, 'job', this.job)
                      axios.post('crm/job/payments/add', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getPayments()
                          this.$emit('update-job')
                          this.close()
                      }).catch(error => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                }
            },
        },
    }
</script>